import React from 'react';
import './EmptyState.css';

const ICONS = {
  complex: (
    <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
      <path
        d="M4 20V8l8-4 8 4v12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 20v-6h6v6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  building: (
    <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
      <path
        d="M5 20V6a1 1 0 011-1h12a1 1 0 011 1v14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M9 9h1.5M13.5 9H15M9 13h1.5M13.5 13H15M9 17h1.5M13.5 17H15"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  ),
  house: (
    <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
      <path
        d="M3 11.5l9-7 9 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10.5v8.5a1.5 1.5 0 001.5 1.5H17.5A1.5 1.5 0 0019 19v-8.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  gateway: (
    <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
      <circle cx="12" cy="12" r="2.2" fill="currentColor" />
      <path
        d="M7.5 7.5a6.4 6.4 0 000 9M16.5 7.5a6.4 6.4 0 010 9M5 5a10 10 0 000 14M19 5a10 10 0 010 14"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
      <circle
        cx="11"
        cy="11"
        r="6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M16 16l4 4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  ),
  list: (
    <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
      <path
        d="M8 7h11M8 12h11M8 17h11"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="4.5" cy="7" r="1" fill="currentColor" />
      <circle cx="4.5" cy="12" r="1" fill="currentColor" />
      <circle cx="4.5" cy="17" r="1" fill="currentColor" />
    </svg>
  ),
};

/**
 * Shared empty placeholder for lists and filters.
 */
export default function EmptyState({
  icon = 'list',
  title,
  subtitle,
  actionLabel,
  onAction,
  secondaryLabel,
  onSecondary,
  compact = false,
  className = '',
}) {
  const glyph = typeof icon === 'string' ? ICONS[icon] || ICONS.list : icon;

  return (
    <div className={`bs-empty${compact ? ' bs-empty--compact' : ''} ${className}`.trim()}>
      <div className="bs-empty__icon" aria-hidden="true">
        {glyph}
      </div>
      <div className="bs-empty__copy">
        {title ? <div className="bs-empty__title">{title}</div> : null}
        {subtitle ? <div className="bs-empty__subtitle">{subtitle}</div> : null}
      </div>
      {(onAction || onSecondary) && (
        <div className="bs-empty__actions">
          {onSecondary ? (
            <button type="button" className="bs-empty__btn" onClick={onSecondary}>
              {secondaryLabel || 'Обновить'}
            </button>
          ) : null}
          {onAction ? (
            <button type="button" className="bs-empty__btn bs-empty__btn--accent" onClick={onAction}>
              {actionLabel || 'Добавить'}
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
}
